
import makerjs from "makerjs";
function C10(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  // console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    R = Param[0].param,
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       r = R * 1 * myZoom,    
    //    h = H * 1 * myZoom,
     h=r,w=r,
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       rd=r/Math.sqrt(2),
       x0=0,y0=0,x1=0,y1=r,x2=r,y2=0,glassH = h, glassW = w;

       if (r !== 0) {
        var TxtR = "R="+R;
    }
   var drawAbnormalShapeC10 = {
       paths: {
        "LeftLine": new makerjs.paths.Line([x0,y0], [x1,y1]),
        "RightArc": new makerjs.paths.Arc([x1,y1], [x2,y2], r, false, true),
        "BottomLine": new makerjs.paths.Line([x2,y2], [x0,y0]),
       }
   };
   var drawAbnormalShapeC10MarkR = {
    paths: {
     "Line": new makerjs.paths.Line([0, 0], [rd, rd]),
    }
};
    makerjs.model.addCaption(drawAbnormalShapeC10MarkR, TxtR, [rd, rd+markShift], [rd+2*markShift, rd+markShift]);//长度文字
   
  plate={
    models: {
      drawAbnormalShapeC10: drawAbnormalShapeC10,
      }
    };
    markers={
      models: {
        drawAbnormalShapeC10: drawAbnormalShapeC10,
        drawAbnormalShapeC10MarkR: drawAbnormalShapeC10MarkR,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default C10;